<template>
  <nav>
    <!-- Cole o HTML do header/navbar do template aqui -->
    <!--    <header id="header" class="header d-flex align-items-center sticky-top">
-->
    <header id="header" class="header d-flex align-items-center fixed-top">
      <div
        class="container-fluid container-xl position-relative d-flex align-items-center"
      >
        <a href="/" class="logo d-flex align-items-center me-auto">
          <!-- Uncomment the line below if you also wish to use an image logo -->
          <img
            src="assets/img/INCUBATOR FINAL PNG.png"
            alt=""
            class="logo-img"
          />
          <!--<h1 class="sitename"> INCULOGO</h1>-->
        </a>

        <nav id="navmenu" class="navmenu">
          <ul>
            <!--<li><a href="/" class="active">{{ $t('common.home') }}</a></li>-->
            <li class="dropdown">
              <a href="#"
                ><span>Incubator</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i
              ></a>
              <ul>
                <li><a href="/projeto">{{ $t('nav.project') }}</a></li>
                <li><a href="/equipa">{{ $t('nav.team') }}</a></li>
              </ul>
            </li>
            <li class="dropdown">
              <a href="#"
                ><span>{{ $t('nav.prostateBiology') }}</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i
              ></a>
              <ul>
                <li><a href="/saudemasculina">{{ $t('nav.prostateHealth') }}</a></li>
                <li class="dropdown">
                  <a href="#"
                    ><span>{{ $t('nav.prostateDiseases') }}</span>
                    <i class="bi bi-chevron-down toggle-dropdown"></i
                  ></a>
                  <ul>
                    <li class="dropdown">
                      <a href="/cancro"
                        >{{ $t('nav.cancer') }}
                        <i class="bi bi-chevron-down toggle-dropdown"></i
                      ></a>

                      <ul>
                        <li><a href="/tratamentocancro">{{ $t('nav.treatment') }}</a></li>
                      </ul>
                    </li>
                    <li><a href="/prostatite">{{ $t('nav.prostatitis') }}</a></li>
                    <li><a href="/hiperplazia">{{ $t('nav.hyperplasia') }}</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li class="dropdown">
              <a href="/analisesclinicas">
                <span>{{ $t('nav.clinicalAnalysis') }}</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i
              ></a>
              <ul>
                <li class="dropdown">
                  <a href="#"
                    ><span>{{ $t('nav.physicalExams') }}</span>
                    <i class="bi bi-chevron-down toggle-dropdown"></i
                  ></a>
                  <ul>
                    <li><a href="/exameimagens">{{ $t('nav.imaging') }}</a></li>
                    <li>
                      <a href="/toqueretal"> {{ $t('nav.rectalExam') }}</a>
                    </li>
                  </ul>
                </li>

                <li class="dropdown">
                  <a href="#"
                    ><span>{{ $t('nav.biologicalExams') }}</span>
                    <i class="bi bi-chevron-down toggle-dropdown"></i
                  ></a>
                  <ul>
                    <li><a href="/examesanguineo">PSA</a></li>
                    <li><a href="/examehistopatologico">{{ $t('nav.histopathological') }}</a></li>
                    <li><a href="/examelipidomica">{{ $t('nav.lipidomics') }}</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <!--  DIAGNOSTICO TERA ACESSO RESTRITO / funcionando perfeitamente-->
            <li class="dropdown">
              <a
                href="#"
                @click.prevent="toggleDropdown"
                data-restricted="true"
              >
                <span>{{ $t('nav.diagnosis') }}</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i>
              </a>

              <ul v-show="dropdownOpen">
                <li>
                  <a href="/diagtoqueretal">{{ $t('nav.rectalResults') }}</a>
                </li>
                <li><a href="/resultadosPSA">{{ $t('nav.psaResults') }}</a></li>
                <li class="dropdown">
                  <a href="/resultadoshistopatologico"
                    >{{ $t('nav.histopathologyResults') }}
                    <i class="bi bi-chevron-down toggle-dropdown"></i
                  ></a>
                  <ul>
                    <li>
                      <a href="/resultadosh&e">{{ $t('nav.heResults') }} </a>
                    </li>
                    <li>
                      <a href="/resultadosihq">{{ $t('nav.ihcResults') }} </a>
                    </li>
                  </ul>
                </li>
                <!--<li>
                  <a href="#">Interpretação Lipidómica </a>
                </li>-->
                <li>
                  <a href="/guidelines">{{ $t('nav.guidelines') }} </a>
                </li>
              </ul>
            </li>

            <!-- LAB VIRTUAL AQUI TERA ACESSO RESTRITO-->
            <li class="dropdown">
              <a
                href="#"
                @click.prevent="toggleDropdown"
                data-restricted="true"
              >
                <span>{{ $t('nav.virtualLab') }}</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i>
              </a>
              <ul v-show="dropdownOpen">
                 <li><a href="/lab3d">{{ $t('nav.lab3d') }}</a></li>
                <li><a href="/salavirtual">{{ $t('nav.classroom') }}</a></li>
                <!--<li><a href="/salavirtual">Cursos</a></li>-->
                 <li><a href="#">{{ $t('nav.molecular') }}</a></li>
                  <li class="dropdown">
                  <a href="#"
                    ><span>{{ $t('nav.histopathology') }}</span>
                    <i class="bi bi-chevron-down toggle-dropdown"></i
                  ></a>
                  <ul>
                    <li><a href="/fixacao">{{ $t('nav.fixation') }}</a></li>
                    <li><a href="/examemacroscopica">{{ $t('nav.macroscopic') }}</a></li>
                    <li>
                      <a href="/desidratacao"
                        >{{ $t('nav.dehydration') }}</a
                      >
                    </li>
                    <li><a href="/inclusao">{{ $t('nav.embedding') }}</a></li>
                    <li><a href="/cortes">{{ $t('nav.sections') }}</a></li>

                    <li class="dropdown">
                      <a href="#"
                        >{{ $t('nav.staining') }}
                        <i class="bi bi-chevron-down toggle-dropdown"></i
                      ></a>

                      <ul>
                        <li><a href="/h&e">H&E</a></li>
                        <li>
                          <a href="/ihq"> IHQ</a>
                        </li>
                      </ul>
                    </li>
                    <li><a href="/montagem">{{ $t('nav.mounting') }}</a></li>
                    <li><a href="/microscopica">{{ $t('nav.microscopy') }}</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <!-- NOTICIAS-->
            <li class="dropdown">
              <a href="#"
                ><span>{{ $t('nav.publications') }}</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i
              ></a>
              <ul>
                <li><a href="/noticias"> {{ $t('nav.news') }}</a></li>
                <li><a href="/eventos">{{ $t('nav.events') }}</a></li>
                <li><a href="/forum">{{ $t('nav.forum') }}</a></li>
                <li><a href="/repositorio">{{ $t('nav.repositories') }}</a></li>
                <li><a href="/videos">{{ $t('nav.videos') }}</a></li>
                <li><a href="/galerias">{{ $t('nav.galleries') }}</a></li>
              </ul>
            </li>
          </ul>
          <i class="mobile-nav-toggle d-xl-none bi bi-list"></i>
        </nav>

        <LanguageSwitcher />

        <!-- Modal Bootstrap -->
        <div
          v-if="showModal"
          class="modal fade show"
          tabindex="-1"
          style="display: block"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('auth.welcome') }}</h5>
                <button
                  type="button"
                  class="btn-close"
                  @click="closeModal"
                  :aria-label="$t('common.close')"
                ></button>
              </div>
              <div class="modal-body">
                <!-- Alertas -->
                <div
                  v-if="successMessage"
                  class="alert alert-success text-center"
                >
                  {{ $message(successMessage) }}
                </div>
                <div v-if="errorMessage" class="alert alert-danger text-center">
                  {{ $message(errorMessage) }}
                </div>

                <!-- Formulário de login -->
                <form @submit.prevent="login">
                  <div class="form-group mb-3">
                    <label for="exampleInputEmail1">{{ $t('common.email') }}</label>
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="bi bi-person"></i>
                      </span>
                      <input
                        v-model="loginForm.email"
                        type="email"
                        class="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        required
                      />
                    </div>
                  </div>

                  <div class="form-group mb-3">
                    <label for="exampleInputPassword1">{{ $t('common.password') }}</label>
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="bi bi-lock"></i>
                      </span>
                      <input
                        v-model="loginForm.password"
                        type="password"
                        class="form-control"
                        id="exampleInputPassword1"
                        required
                      />
                    </div>
                  </div>

                  <button
                    type="submit"
                    id="btn-getstarted"
                    class="btn btn-gradient w-100"
                  >
                    <i class="bi bi-box-arrow-in-right me-2"></i> {{ $t('auth.signIn') }}
                  </button>
                  <br />
                  <div class="text-center mt-3">
                    {{ $t('auth.noAccount') }}
                    <a href="#" @click.prevent="openRegisterModal">
                      {{ $t('auth.requestAccess') }}
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- MODAL DE REGISTRO -->
        <div
          v-if="showRegisterModal"
          class="modal fade show"
          tabindex="-1"
          style="display: block"
        >
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" style="text-align: center">
                  <b style="color: black"
                    >{{ $t('auth.accessTitle') }}</b
                  >
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  @click="closeRegisterModal"
                  :aria-label="$t('common.close')"
                ></button>
              </div>
              <div class="modal-body">
                <div
                  v-if="registerSuccessMessage"
                  class="alert alert-success text-center"
                >
                  {{ $message(registerSuccessMessage) }}
                </div>
                <div
                  v-if="registerErrorMessage"
                  class="alert alert-danger text-center"
                >
                  {{ $message(registerErrorMessage) }}
                </div>

                <form @submit.prevent="submitRegister">
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <label>{{ $t('common.name') }} <span class="text-danger">*</span></label>
                      <input
                        v-model="registerForm.name"
                        type="text"
                        class="form-control"
                        required
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label>{{ $t('common.email') }} <span class="text-danger">*</span></label>
                      <input
                        v-model="registerForm.email"
                        type="email"
                        class="form-control"
                        required
                      />
                    </div>

                    <div class="col-md-6 mb-3">
                      <label>{{ $t('common.password') }} <span class="text-danger">*</span></label>
                      <input
                        v-model="registerForm.password"
                        type="password"
                        class="form-control"
                        required
                        :placeholder="$t('auth.minimumPassword')"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label>{{ $t('auth.age') }} <span class="text-danger">*</span></label>
                      <input
                        v-model="registerForm.idade"
                        type="number"
                        class="form-control"
                        required
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="genero"
                        >{{ $t('auth.gender') }} <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <select
                          v-model="registerForm.genero"
                          id="genero"
                          class="form-select"
                          required
                        >
                          <option disabled value="">{{ $t('auth.select') }}</option>
                          <option value="masculino">{{ $t('auth.male') }}</option>
                          <option value="feminino">{{ $t('auth.female') }}</option>
                          <option value="Nao Revelar">
                            {{ $t('auth.undisclosed') }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-6 mb-3">
                      <label
                        >{{ $t('auth.profession') }} <span class="text-danger">*</span></label
                      >
                      <input
                        v-model="registerForm.profissao"
                        type="text"
                        class="form-control"
                        required
                        :placeholder="$t('auth.studentExample')"
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="pais"
                        >{{ $t('auth.nationality') }} <span class="text-danger">*</span></label
                      >
                      <select
                        v-model="registerForm.pais"
                        id="pais"
                        class="form-select"
                        required
                      >
                        <option disabled value="">
                          {{ $t('auth.selectCountry') }}
                        </option>
                        <option value="Afeganistão">{{ countryLabel('Afeganistão') }}</option>
                        <option value="África do Sul">{{ countryLabel('África do Sul') }}</option>
                        <option value="Albânia">{{ countryLabel('Albânia') }}</option>
                        <option value="Alemanha">{{ countryLabel('Alemanha') }}</option>
                        <option value="Andorra">{{ countryLabel('Andorra') }}</option>
                        <option value="Angola">{{ countryLabel('Angola') }}</option>
                        <option value="Antígua e Barbuda">
                          {{ countryLabel('Antígua e Barbuda') }}
                        </option>
                        <option value="Arábia Saudita">{{ countryLabel('Arábia Saudita') }}</option>
                        <option value="Argélia">{{ countryLabel('Argélia') }}</option>
                        <option value="Argentina">{{ countryLabel('Argentina') }}</option>
                        <option value="Armênia">{{ countryLabel('Armênia') }}</option>
                        <option value="Austrália">{{ countryLabel('Austrália') }}</option>
                        <option value="Áustria">{{ countryLabel('Áustria') }}</option>
                        <option value="Azerbaijão">{{ countryLabel('Azerbaijão') }}</option>
                        <option value="Bahamas">{{ countryLabel('Bahamas') }}</option>
                        <option value="Bangladesh">{{ countryLabel('Bangladesh') }}</option>
                        <option value="Barbados">{{ countryLabel('Barbados') }}</option>
                        <option value="Barein">{{ countryLabel('Barein') }}</option>
                        <option value="Bélgica">{{ countryLabel('Bélgica') }}</option>
                        <option value="Belize">{{ countryLabel('Belize') }}</option>
                        <option value="Benim">{{ countryLabel('Benim') }}</option>
                        <option value="Butão">{{ countryLabel('Butão') }}</option>
                        <option value="Bolívia">{{ countryLabel('Bolívia') }}</option>
                        <option value="Bósnia e Herzegovina">
                          {{ countryLabel('Bósnia e Herzegovina') }}
                        </option>
                        <option value="Botsuana">{{ countryLabel('Botsuana') }}</option>
                        <option value="Brasil">{{ countryLabel('Brasil') }}</option>
                        <option value="Brunei">{{ countryLabel('Brunei') }}</option>
                        <option value="Bulgária">{{ countryLabel('Bulgária') }}</option>
                        <option value="Burquina Faso">{{ countryLabel('Burquina Faso') }}</option>
                        <option value="Burundi">{{ countryLabel('Burundi') }}</option>
                        <option value="Cabo Verde">{{ countryLabel('Cabo Verde') }}</option>
                        <option value="Camarões">{{ countryLabel('Camarões') }}</option>
                        <option value="Camboja">{{ countryLabel('Camboja') }}</option>
                        <option value="Canadá">{{ countryLabel('Canadá') }}</option>
                        <option value="Catar">{{ countryLabel('Catar') }}</option>
                        <option value="Chade">{{ countryLabel('Chade') }}</option>
                        <option value="Chile">{{ countryLabel('Chile') }}</option>
                        <option value="China">{{ countryLabel('China') }}</option>
                        <option value="Chipre">{{ countryLabel('Chipre') }}</option>
                        <option value="Colômbia">{{ countryLabel('Colômbia') }}</option>
                        <option value="Comores">{{ countryLabel('Comores') }}</option>
                        <option value="Congo">{{ countryLabel('Congo') }}</option>
                        <option value="Coreia do Norte">{{ countryLabel('Coreia do Norte') }}</option>
                        <option value="Coreia do Sul">{{ countryLabel('Coreia do Sul') }}</option>
                        <option value="Costa do Marfim">{{ countryLabel('Costa do Marfim') }}</option>
                        <option value="Costa Rica">{{ countryLabel('Costa Rica') }}</option>
                        <option value="Croácia">{{ countryLabel('Croácia') }}</option>
                        <option value="Cuba">{{ countryLabel('Cuba') }}</option>
                        <option value="Dinamarca">{{ countryLabel('Dinamarca') }}</option>
                        <option value="Djibuti">{{ countryLabel('Djibuti') }}</option>
                        <option value="Dominica">{{ countryLabel('Dominica') }}</option>
                        <option value="Egito">{{ countryLabel('Egito') }}</option>
                        <option value="El Salvador">{{ countryLabel('El Salvador') }}</option>
                        <option value="Emirados Árabes Unidos">
                          {{ countryLabel('Emirados Árabes Unidos') }}
                        </option>
                        <option value="Equador">{{ countryLabel('Equador') }}</option>
                        <option value="Eritreia">{{ countryLabel('Eritreia') }}</option>
                        <option value="Eslováquia">{{ countryLabel('Eslováquia') }}</option>
                        <option value="Eslovênia">{{ countryLabel('Eslovênia') }}</option>
                        <option value="Espanha">{{ countryLabel('Espanha') }}</option>
                        <option value="Estados Unidos">{{ countryLabel('Estados Unidos') }}</option>
                        <option value="Estônia">{{ countryLabel('Estônia') }}</option>
                        <option value="Eswatini">{{ countryLabel('Eswatini') }}</option>
                        <option value="Etiópia">{{ countryLabel('Etiópia') }}</option>
                        <option value="Fiji">{{ countryLabel('Fiji') }}</option>
                        <option value="Filipinas">{{ countryLabel('Filipinas') }}</option>
                        <option value="Finlândia">{{ countryLabel('Finlândia') }}</option>
                        <option value="França">{{ countryLabel('França') }}</option>
                        <option value="Gabão">{{ countryLabel('Gabão') }}</option>
                        <option value="Gâmbia">{{ countryLabel('Gâmbia') }}</option>
                        <option value="Gana">{{ countryLabel('Gana') }}</option>
                        <option value="Geórgia">{{ countryLabel('Geórgia') }}</option>
                        <option value="Granada">{{ countryLabel('Granada') }}</option>
                        <option value="Grécia">{{ countryLabel('Grécia') }}</option>
                        <option value="Guatemala">{{ countryLabel('Guatemala') }}</option>
                        <option value="Guiana">{{ countryLabel('Guiana') }}</option>
                        <option value="Guiné">{{ countryLabel('Guiné') }}</option>
                        <option value="Guiné-Bissau">{{ countryLabel('Guiné-Bissau') }}</option>
                        <option value="Guiné Equatorial">
                          {{ countryLabel('Guiné Equatorial') }}
                        </option>
                        <option value="Haiti">{{ countryLabel('Haiti') }}</option>
                        <option value="Holanda">{{ countryLabel('Holanda') }}</option>
                        <option value="Honduras">{{ countryLabel('Honduras') }}</option>
                        <option value="Hungria">{{ countryLabel('Hungria') }}</option>
                        <option value="Iémen">{{ countryLabel('Iémen') }}</option>
                        <option value="Ilhas Marshall">{{ countryLabel('Ilhas Marshall') }}</option>
                        <option value="Ilhas Salomão">{{ countryLabel('Ilhas Salomão') }}</option>
                        <option value="Índia">{{ countryLabel('Índia') }}</option>
                        <option value="Indonésia">{{ countryLabel('Indonésia') }}</option>
                        <option value="Irã">{{ countryLabel('Irã') }}</option>
                        <option value="Iraque">{{ countryLabel('Iraque') }}</option>
                        <option value="Irlanda">{{ countryLabel('Irlanda') }}</option>
                        <option value="Islândia">{{ countryLabel('Islândia') }}</option>
                        <option value="Israel">{{ countryLabel('Israel') }}</option>
                        <option value="Itália">{{ countryLabel('Itália') }}</option>
                        <option value="Jamaica">{{ countryLabel('Jamaica') }}</option>
                        <option value="Japão">{{ countryLabel('Japão') }}</option>
                        <option value="Jordânia">{{ countryLabel('Jordânia') }}</option>
                        <option value="Kosovo">{{ countryLabel('Kosovo') }}</option>
                        <option value="Kuwait">{{ countryLabel('Kuwait') }}</option>
                        <option value="Laos">{{ countryLabel('Laos') }}</option>
                        <option value="Lesoto">{{ countryLabel('Lesoto') }}</option>
                        <option value="Letônia">{{ countryLabel('Letônia') }}</option>
                        <option value="Líbano">{{ countryLabel('Líbano') }}</option>
                        <option value="Libéria">{{ countryLabel('Libéria') }}</option>
                        <option value="Líbia">{{ countryLabel('Líbia') }}</option>
                        <option value="Liechtenstein">{{ countryLabel('Liechtenstein') }}</option>
                        <option value="Lituânia">{{ countryLabel('Lituânia') }}</option>
                        <option value="Luxemburgo">{{ countryLabel('Luxemburgo') }}</option>
                        <option value="Macedônia do Norte">
                          {{ countryLabel('Macedônia do Norte') }}
                        </option>
                        <option value="Madagáscar">{{ countryLabel('Madagáscar') }}</option>
                        <option value="Malásia">{{ countryLabel('Malásia') }}</option>
                        <option value="Malaui">{{ countryLabel('Malaui') }}</option>
                        <option value="Maldivas">{{ countryLabel('Maldivas') }}</option>
                        <option value="Mali">{{ countryLabel('Mali') }}</option>
                        <option value="Malta">{{ countryLabel('Malta') }}</option>
                        <option value="Marrocos">{{ countryLabel('Marrocos') }}</option>
                        <option value="Maurícia">{{ countryLabel('Maurícia') }}</option>
                        <option value="Mauritânia">{{ countryLabel('Mauritânia') }}</option>
                        <option value="México">{{ countryLabel('México') }}</option>
                        <option value="Micronésia">{{ countryLabel('Micronésia') }}</option>
                        <option value="Moçambique">{{ countryLabel('Moçambique') }}</option>
                        <option value="Moldávia">{{ countryLabel('Moldávia') }}</option>
                        <option value="Mônaco">{{ countryLabel('Mônaco') }}</option>
                        <option value="Mongólia">{{ countryLabel('Mongólia') }}</option>
                        <option value="Montenegro">{{ countryLabel('Montenegro') }}</option>
                        <option value="Myanmar">{{ countryLabel('Myanmar') }}</option>
                        <option value="Namíbia">{{ countryLabel('Namíbia') }}</option>
                        <option value="Nauru">{{ countryLabel('Nauru') }}</option>
                        <option value="Nepal">{{ countryLabel('Nepal') }}</option>
                        <option value="Nicarágua">{{ countryLabel('Nicarágua') }}</option>
                        <option value="Níger">{{ countryLabel('Níger') }}</option>
                        <option value="Nigéria">{{ countryLabel('Nigéria') }}</option>
                        <option value="Noruega">{{ countryLabel('Noruega') }}</option>
                        <option value="Nova Zelândia">{{ countryLabel('Nova Zelândia') }}</option>
                        <option value="Omã">{{ countryLabel('Omã') }}</option>
                        <option value="Palau">{{ countryLabel('Palau') }}</option>
                        <option value="Panamá">{{ countryLabel('Panamá') }}</option>
                        <option value="Papua-Nova Guiné">
                          {{ countryLabel('Papua-Nova Guiné') }}
                        </option>
                        <option value="Paquistão">{{ countryLabel('Paquistão') }}</option>
                        <option value="Paraguai">{{ countryLabel('Paraguai') }}</option>
                        <option value="Peru">{{ countryLabel('Peru') }}</option>
                        <option value="Polônia">{{ countryLabel('Polônia') }}</option>
                        <option value="Portugal">{{ countryLabel('Portugal') }}</option>
                        <option value="Quênia">{{ countryLabel('Quênia') }}</option>
                        <option value="Quirguistão">{{ countryLabel('Quirguistão') }}</option>
                        <option value="Reino Unido">{{ countryLabel('Reino Unido') }}</option>
                        <option value="República Centro-Africana">
                          {{ countryLabel('República Centro-Africana') }}
                        </option>
                        <option value="República Democrática do Congo">
                          {{ countryLabel('República Democrática do Congo') }}
                        </option>
                        <option value="República Dominicana">
                          {{ countryLabel('República Dominicana') }}
                        </option>
                        <option value="República Tcheca">
                          {{ countryLabel('República Tcheca') }}
                        </option>
                        <option value="Romênia">{{ countryLabel('Romênia') }}</option>
                        <option value="Ruanda">{{ countryLabel('Ruanda') }}</option>
                        <option value="Rússia">{{ countryLabel('Rússia') }}</option>
                        <option value="San Marino">{{ countryLabel('San Marino') }}</option>
                        <option value="Santa Lúcia">{{ countryLabel('Santa Lúcia') }}</option>
                        <option value="São Cristóvão e Nevis">
                          {{ countryLabel('São Cristóvão e Nevis') }}
                        </option>
                        <option value="São Tomé e Príncipe">
                          {{ countryLabel('São Tomé e Príncipe') }}
                        </option>
                        <option value="São Vicente e Granadinas">
                          {{ countryLabel('São Vicente e Granadinas') }}
                        </option>
                        <option value="Seicheles">{{ countryLabel('Seicheles') }}</option>
                        <option value="Senegal">{{ countryLabel('Senegal') }}</option>
                        <option value="Serra Leoa">{{ countryLabel('Serra Leoa') }}</option>
                        <option value="Sérvia">{{ countryLabel('Sérvia') }}</option>
                        <option value="Singapura">{{ countryLabel('Singapura') }}</option>
                        <option value="Síria">{{ countryLabel('Síria') }}</option>
                        <option value="Somália">{{ countryLabel('Somália') }}</option>
                        <option value="Sri Lanka">{{ countryLabel('Sri Lanka') }}</option>
                        <option value="Sudão">{{ countryLabel('Sudão') }}</option>
                        <option value="Sudão do Sul">{{ countryLabel('Sudão do Sul') }}</option>
                        <option value="Suécia">{{ countryLabel('Suécia') }}</option>
                        <option value="Suíça">{{ countryLabel('Suíça') }}</option>
                        <option value="Suriname">{{ countryLabel('Suriname') }}</option>
                        <option value="Tailândia">{{ countryLabel('Tailândia') }}</option>
                        <option value="Tanzânia">{{ countryLabel('Tanzânia') }}</option>
                        <option value="Tchéquia">{{ countryLabel('Tchéquia') }}</option>
                        <option value="Togo">{{ countryLabel('Togo') }}</option>
                        <option value="Tonga">{{ countryLabel('Tonga') }}</option>
                        <option value="Trinidad e Tobago">
                          {{ countryLabel('Trinidad e Tobago') }}
                        </option>
                        <option value="Tunísia">{{ countryLabel('Tunísia') }}</option>
                        <option value="Turcomenistão">{{ countryLabel('Turcomenistão') }}</option>
                        <option value="Turquia">{{ countryLabel('Turquia') }}</option>
                        <option value="Tuvalu">{{ countryLabel('Tuvalu') }}</option>
                        <option value="Ucrânia">{{ countryLabel('Ucrânia') }}</option>
                        <option value="Uganda">{{ countryLabel('Uganda') }}</option>
                        <option value="Uruguai">{{ countryLabel('Uruguai') }}</option>
                        <option value="Uzbequistão">{{ countryLabel('Uzbequistão') }}</option>
                        <option value="Vanuatu">{{ countryLabel('Vanuatu') }}</option>
                        <option value="Vaticano">{{ countryLabel('Vaticano') }}</option>
                        <option value="Venezuela">{{ countryLabel('Venezuela') }}</option>
                        <option value="Vietnã">{{ countryLabel('Vietnã') }}</option>
                        <option value="Zâmbia">{{ countryLabel('Zâmbia') }}</option>
                        <option value="Zimbábue">{{ countryLabel('Zimbábue') }}</option>
                      </select>
                    </div>

                    <div class="col-md-12 mb-3">
                      <label
                        >{{ $t('auth.enrolmentProof') }}
                        <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <span class="input-group-text">
                          <i class="bi bi-paperclip"></i>
                        </span>
                        <input
                          type="file"
                          class="form-control"
                          @change="handleFileUpload($event, 1)"
                          required
                        />
                      </div>
                      <b id="idnota">
                        {{ $t('auth.documentHint') }}
                      </b>
                    </div>

                    <div class="col-md-12 mb-3">
                      <label
                        >{{ $t('auth.paymentProof') }}
                        <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <span class="input-group-text">
                          <i class="bi bi-paperclip"></i>
                        </span>
                        <input
                          type="file"
                          class="form-control"
                          @change="handleFileUpload($event, 2)"
                          required
                        />
                      </div>
                    </div>

                    <br />

                    <br />
                  </div>

                  <button
                    type="submit"
                    id="btn-getstarted"
                    class="btn btn-gradient w-100"
                  >
                    <i class="bi bi-send"></i> {{ $t('auth.submitRequest') }}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal backdrop -->
        <div
          v-if="showModal || showRegisterModal"
          class="modal-backdrop fade show"
        ></div>

        <!-- Modal backdrop -->
        <div v-if="showModal" class="modal-backdrop fade show"></div>
      </div>
    </header>
  </nav>
</template>

<script>
import axios from "axios";
import LanguageSwitcher from "./LanguageSwitcher.vue";
import countryCodes from "../i18n/countries.json";
import { localeTag } from "../i18n";
import { API_ENDPOINT } from "../main.js";
import { isSessionValid, FIFTEEN_MINUTES } from "../config.js";

export default {
  name: "AppNavbar",
  components: { LanguageSwitcher },

  data() {
    return {
      user: null,
      showModal: false,
      dropdownOpen: false,
      loginForm: { email: "", password: "", remember: false },
      errorMessage: "",
      successMessage: "",
      showRegisterModal: false,
      registerForm: {
        name: "",
        email: "",
        password: "",
        idade: "",
        genero: "",
        pais: "",
        profissao: "",
        attachment1: null,
        attachment2: null,
      },
      registerSuccessMessage: "",
      registerErrorMessage: "",
    };
  },

  methods: {
    countryLabel(value) {
      const code = countryCodes[value];
      return code ? new Intl.DisplayNames([localeTag()], { type: "region" }).of(code) : value;
    },
    handleFileUpload(event, index) {
      const file = event.target.files[0];
      if (index === 1) this.registerForm.attachment1 = file;
      if (index === 2) this.registerForm.attachment2 = file;
    },
    openRegisterModal() {
      this.showModal = false; // fecha o modal de login
      this.showRegisterModal = true; // abre o modal de registro
    },
    closeRegisterModal() {
      this.showRegisterModal = false;
      this.registerForm.name = "";
      this.registerForm.email = "";
      this.registerForm.password = "";
      this.registerForm.idade = "";
      this.registerForm.genero = "";
      this.registerForm.profissao = "";
      this.registerForm.pais = "";
      this.registerSuccessMessage = "";
      this.registerErrorMessage = "";
    },
    async submitRegister() {
      try {
        if (!this.registerForm.attachment1 || !this.registerForm.attachment2) {
          this.registerErrorMessage =
            "auth.attachmentsRequired";
          return;
        }

        const formData = new FormData();
        formData.append("name", this.registerForm.name);
        formData.append("email", this.registerForm.email);
        formData.append("password", this.registerForm.password);
        formData.append("idade", this.registerForm.idade);
        formData.append("genero", this.registerForm.genero);
        formData.append("profissao", this.registerForm.profissao);
        formData.append("pais", this.registerForm.pais);
        formData.append("attachment1", this.registerForm.attachment1);
        formData.append("attachment2", this.registerForm.attachment2);

        const res = await axios.post(
          `${API_ENDPOINT}/api/medical-request`,
          formData
        );

        if (res.data.success) {
          this.registerSuccessMessage =
            "auth.requestSent";
          this.registerErrorMessage = "";

          // limpa o formulário
          this.registerForm = {
            name: "",
            email: "",
            password: "",
            profissao: "",
            idade: "",
            genero: "",
            pais: "",
            attachment1: null,
            attachment2: null,
          };

          setTimeout(() => {
            this.showRegisterModal = false;
            this.registerSuccessMessage = "";
          }, 5000);
        } else {
          this.registerErrorMessage =
            res.data.message || "auth.requestError";
          this.registerSuccessMessage = "";
        }
      } catch (err) {
        this.registerErrorMessage = "auth.requestError";
        this.registerSuccessMessage = "";
        console.error(err);
      }
    },
    // --- MÉTODOS ATUALIZADOS PARA O MENU MOBILE ---
    toggleMobileNav(event) {
      event.preventDefault();
      const navmenu = document.querySelector("#navmenu");
      if (navmenu) {
        /* antes estava assim funcionando
        navmenu.classList.toggle("mobile-nav-active");
        const toggleIcon = event.currentTarget;
        toggleIcon.classList.toggle("bi-list");
        toggleIcon.classList.toggle("bi-x");*/
        navmenu.classList.toggle("mobile-nav-active");
        event.currentTarget.classList.toggle("bi-list");
        event.currentTarget.classList.toggle("bi-x");
      }
    },
    handleMobileDropdown(event) {
      if (!document.querySelector("#navmenu.mobile-nav-active")) return;

      event.preventDefault();
      const dropdown = event.target.closest(".dropdown");
      if (!dropdown) return;

      const mainLink = dropdown.querySelector("a");
      const isRestricted =
        mainLink && mainLink.getAttribute("data-restricted") === "true";

      // **A LÓGICA CORRIGIDA ESTÁ AQUI**
      // Se o menu for restrito E o usuário NÃO estiver logado, mostre o modal.
      if (isRestricted && !isSessionValid()) {
        this.showModal = true;
        return; // Para a execução aqui.
      }

      // Se o menu for restrito e o usuário JÁ ESTIVER LOGADO,
      // ou se for um dropdown normal, execute a lógica de abrir/fechar.
      // Esta parte agora funciona para TODOS os dropdowns no mobile.
      const parentUl = dropdown.closest("ul");
      if (parentUl) {
        parentUl.querySelectorAll(".dropdown.active").forEach((d) => {
          if (d !== dropdown) {
            d.classList.remove("active");
            d.querySelector("ul")?.classList.remove("dropdown-active");
          }
        });
      }

      dropdown.classList.toggle("active");
      const submenu = dropdown.querySelector("ul");
      if (submenu) {
        submenu.classList.toggle("dropdown-active");
      }
    },
    
    toggleDropdown() {
      if (isSessionValid()) {
        // Sessão válida, pode abrir dropdown
        const storedUser = JSON.parse(localStorage.getItem("user"));
        this.user = storedUser;
        this.dropdownOpen = !this.dropdownOpen;
      } else {
        // Sessão inválida, abre modal de login
        this.showModal = true;
      }
    },
    checkAccess() {
      if (!this.isLoggedIn()) {
        this.showModal = true;
      }
    },
    isLoggedIn() {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const loginTime = localStorage.getItem("loginTime");
      return (
        storedUser && loginTime && Date.now() - loginTime < FIFTEEN_MINUTES
      );
    },

    handleAccess() {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const loginTime = localStorage.getItem("loginTime");

      if (storedUser && loginTime && Date.now() - loginTime < FIFTEEN_MINUTES) {
        this.user = storedUser;
      } else {
        this.showModal = true;
      }
    },

    closeModal() {
      this.showModal = false;
      this.errorMessage = "";
      this.successMessage = "";
    },

    async login() {
      try {
        const { data } = await axios.post(
          `${API_ENDPOINT}/api/login`,
          this.loginForm,
          { withCredentials: true }
        );

        if (data.user) {
          this.user = data.user;
          localStorage.setItem("user", JSON.stringify(data.user));
          localStorage.setItem("loginTime", Date.now());

          this.successMessage = "auth.loginSuccess";
          this.errorMessage = "";
          this.dropdownOpen = true;

          setTimeout(() => {
            this.showModal = false;
            this.successMessage = "";
          }, 2000);
        } else {
          this.errorMessage = data.message || "auth.invalidCredentials";
          this.successMessage = "";
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          this.errorMessage = err.response.data.message;
        } else {
          this.errorMessage = "auth.loginError";
        }
        this.successMessage = "";
      }
    },

    async logout() {
      try {
        await axios.post(
          `${API_ENDPOINT}/api/logout`,
          {},
          { withCredentials: true }
        );
        this.user = null;
        this.dropdownOpen = false;
        localStorage.removeItem("user");
        localStorage.removeItem("loginTime");
      } catch (err) {
        console.error("Erro ao fazer logout:", err);
      }
    },
  },
  async mounted() {
    // --- INICIALIZAÇÃO DOS EVENTOS DO MENU ---
    this.$nextTick(() => {
      const mobileNavToggle = document.querySelector(".mobile-nav-toggle");
      if (mobileNavToggle) {
        mobileNavToggle.addEventListener("click", this.toggleMobileNav);
      }

      const navMenu = document.querySelector("#navmenu");
      if (navMenu) {
        navMenu.addEventListener("click", (event) => {
          // Verifica se o clique foi no ícone de dropdown
          if (event.target.matches(".toggle-dropdown")) {
            this.handleMobileDropdown(event);
          }
        });
      }
    });
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const loginTime = localStorage.getItem("loginTime");

    if (storedUser && loginTime && Date.now() - loginTime < FIFTEEN_MINUTES) {
      this.user = storedUser;
    } else {
      try {
        const { data } = await axios.get(`${API_ENDPOINT}/api/user`, {
          withCredentials: true,
        });
        if (data.user) {
          this.user = data.user;
          localStorage.setItem("user", JSON.stringify(data.user));
          localStorage.setItem("loginTime", Date.now());
        }
      } catch (err) {
        console.warn("Utilizador não logado:", err);
      }
    }
  },

  beforeUnmount() {
    // Limpeza dos eventos
    const mobileNavToggle = document.querySelector(".mobile-nav-toggle");
    if (mobileNavToggle) {
      mobileNavToggle.removeEventListener("click", this.toggleMobileNav);
    }
    // A delegação de evento não precisa de limpeza individual aqui,
    // pois o listener está no #navmenu que será destruído com o componente.
  },
};
</script>

<style scoped>
#idnota {
  color: #10b2bb;
  font-family: "Times New Roman", Times, serif;
  font-size: 15px;
}
/* Adicione aqui o CSS específico do Navbar, ou importe global no main.js */
/* 
#header {
  background: linear-gradient(to bottom, red 0%, green 100%);
  border-bottom: none;  
} */
label {
  font-weight: bold;
}
#header {
  background: linear-gradient(
    to bottom,
    #c8c8c8 0%,
    #dcdcdc 40%,
    #f0f0f0 80%,
    #f8f8f8 100%
  );
  border-bottom: none;
  min-height: 100px; /* aumenta altura para destacar o degradê */
}
#header {
  z-index: 1030; /* igual ao do Bootstrap navbar */
  width: 100%;
}
.btn-gradient {
  background: linear-gradient(to right, orange, #05b4c6);
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem; /* arredondamento */
  padding: 0.75rem 1.5rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.btn-gradient:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  opacity: 0.95;
}

.btn-gradient:active {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
}

/* Adicione este CSS dentro da sua tag <style scoped> */

/*--------------------------------------------------------------
# Mobile Navigation
--------------------------------------------------------------*/
.mobile-nav-toggle {
  color: #364d59;
  font-size: 28px;
  cursor: pointer;
  display: none;
  line-height: 0;
  transition: 0.5s;
}

@media (min-width: 1200px) {
  #navmenu {
    margin-right: 0;
    order: 1;
  }
}

@media (min-width: 1200px) and (max-width: 1399.98px) {
  #navmenu > ul > li > a {
    padding-right: 8px;
    padding-left: 8px;
    font-size: 15px;
  }
}

@media (max-width: 1199.98px) {
  .mobile-nav-toggle {
    display: block;
  }

  .navmenu ul {
    display: none;
  }
}

.navmenu.mobile-nav-active {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  overflow-y: auto;
  background: rgba(33, 37, 41, 0.9); /* Fundo semi-transparente */
  transition: 0.3s;
}

.navmenu.mobile-nav-active > ul {
  display: block; /* ESSA É A REGRA CHAVE QUE MOSTRA O MENU */
  position: absolute;
  top: 55px;
  right: 15px;
  bottom: 15px;
  left: 15px;
  padding: 10px 0;
  border-radius: 8px;
  background-color: #fff;
  overflow-y: auto;
  transition: 0.3s;
  z-index: 9998;
}

.navmenu.mobile-nav-active .dropdown > a,
.navmenu.mobile-nav-active .dropdown > a:focus {
  padding: 10px 20px;
  font-size: 15px;
  color: #364d59;
}

.navmenu.mobile-nav-active .dropdown > a:hover,
.navmenu.mobile-nav-active .dropdown.active > a {
  color: #008374; /* Cor do item ativo */
}

/* Regra para mostrar os submenus quando o dropdown está ativo */
.navmenu.mobile-nav-active .dropdown .dropdown-active {
  display: block !important;
}
</style>
